import { Classifier } from '@/commons/types'
import { TranslationUtils } from '@/commons/utils/translations'

export class ClassifiersUtils {
    static findLikeClassifier (classifiers: Array<Classifier> | undefined, pattern: RegExp): Classifier | undefined {
        if (!classifiers) {
            return undefined
        }
        return classifiers.find((classifier: Classifier) => classifier.code.match(pattern))
    }

    static findClassifier (classifiers: Array<Classifier> | undefined, code: string | null): Classifier | undefined {
        if (!code || !classifiers) {
            return undefined
        }
        return classifiers.find((classifier: Classifier) => classifier.code === code)
    }

    static sanitizePlaceOfBirth (placeOfBirth: string): string {
        if (!placeOfBirth) {
            return ''
        }
        const placeOfBirthDetails = placeOfBirth.split('/')
        const regex = /ÄRA KASUTA/ig
        return placeOfBirthDetails[0] ? placeOfBirthDetails[0].replace(regex, '').trim() : ''
    }

    static translateByCode (classifierList: Array<Classifier> | undefined, code: string| null): string {
        const classifier: Classifier | undefined = this.findClassifier(classifierList, code)
        return classifier ? TranslationUtils.translateClassifier(classifier) : ''
    }

    static sortAlphabetically (classifiers: Array<Classifier>): Array<Classifier> {
        return classifiers.sort(function (a, b) {
            const labelA = a.label.toUpperCase().trim()
            const labelB = b.label.toUpperCase().trim()
            if (labelA < labelB) {
                return -1
            }
            if (labelA > labelB) {
                return 1
            }
            return 0
        })
    }
}
